import React from 'react';
import clsx from 'clsx';
import {
  Table,
  Loader, Icon,
} from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const CompactTableRow = ({
  rowId,
  rowText,
  numberOfColumns,
  className,
  isLoading,
  children,
  active,
  error,
  warning,
}) => (
  <Table.Row
    verticalAlign="middle"
    className={clsx('aridhia-compact-table-row', className)}
    active={active}
    error={!!error}
    warning={warning}
  >
    <Table.Cell colSpan={numberOfColumns}>
      {warning && (<Icon name="warning circle" />)}
      {error && !warning && (<Icon name="times circle" />)}
      {rowId && <FormattedMessage id={rowId} />}
      {rowText}
      {isLoading && <Loader active inline size="tiny" className="aridhia-loader-right" />}
      {children}
    </Table.Cell>
  </Table.Row>
);

export default CompactTableRow;
